import request from "../request";
import sysrequest from "../sysrequest";
// 潛在客戶專案列表

const api = {
  // 查詢潛在客戶列表
  pocxpj_search(data) {
    const obj = {
      url: "/bid/demo_v1/potential_customer_project/search/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  pocxpj_create(data) {
    const obj = {
      url: "/bid/demo_v1/potential_customer_project/create/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
  pocxpj_update(data) {
    const obj = {
      url: "/bid/demo_v1/potential_customer_project/update/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
  pocxpj_delete(data) {
    const obj = {
      url: "/bid/demo_v1/potential_customer_project/delete/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
